export const ROOT = '/';
export const PROFILE_ROUTE = '/profile'; // temp
export const PRAYER_ROUTE = '/prayer/:id'; // temp
export const PRAYER_HUB_ROUTE = '/prayer-hub/:id'; 
export const ADD_ROUTE = '/add';
export const LOGIN_ROUTE = '/login';
